import SkeletonLoader from "./skeleton-loader";

import { Retry } from "../../Assets/Icons";

export default function WidgetFormSkeleton({ isRefreshing = false, fieldCount = 2 }) {
  return (
    <div className="widget-form-skeleton" data-refreshing={isRefreshing}>
      <SkeletonLoader className="border--rounded-sm" width="60%" height="20px" />
      <div className="widget-form-skeleton__fields">
        {Array.from({ length: fieldCount }).map((_, i) => (
          <div key={i} className="widget-form-skeleton__field">
            <SkeletonLoader className="border--rounded-sm" width="35%" height="12px" />
            <SkeletonLoader className="border--rounded-md" width="100%" height="44px" />
          </div>
        ))}
      </div>
      <SkeletonLoader className="border--rounded-md" width="100%" height="48px" />
      {isRefreshing && (
        <div className="widget-form-skeleton__refresh" role="status" aria-live="polite">
          <Retry className="widget-form-skeleton__refresh-icon" />
          <span>Refreshing form…</span>
        </div>
      )}
    </div>
  );
}
